import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { CandidaturaService } from 'src/app/services/candidatura.service'
import { BlacklistCandidaturaService } from 'src/app/services/blacklistcandidatura.service'
import { Blacklist } from 'src/app/models/blacklist.model'
import { BlacklistCandidaturaCsvDTO } from 'src/app/models/blacklistCandidaturaCsvDTO.model';
import { Utils } from 'src/app/utils/utils';

@Component({
  selector: 'cadastro-massa-blacklistprecandidatos',
  templateUrl: './blacklistprecandidatos-csv-import.component.html',
  styleUrls: ['./blacklistprecandidatos-csv-import.component.css']
})
export class BlacklistPrecandidatosCsvComponent implements OnInit {
  public newBlacklistArray:  BlacklistCandidaturaCsvDTO[] = [];

  formCadastroBlacklists: FormGroup;
  candidaturaId: any;
  idEleicao: any;
  token: any;
  listaBlacklist: any;
  novoLoginBlacklist: any;
  newBlacklistDTO:  BlacklistCandidaturaCsvDTO = new  BlacklistCandidaturaCsvDTO();

  constructor(
    public candidaturaService: CandidaturaService,
    public blacklistService: BlacklistCandidaturaService,
    public utils: Utils,
    protected messageService: MessageService
  ) { }

  async ngOnInit() {
    this.novoLoginBlacklist = new Blacklist();
    this.idEleicao = JSON.parse(sessionStorage.getItem("eleicaoClicadaParametrizacao")).id;
    this.token = sessionStorage.getItem("token");
    await this.listarDadosExistentes();
    this.formCadastroBlacklists = new FormGroup({
      login: new FormControl()
    })
  }

  async listarDadosExistentes(){
    await this.candidaturaService.listarPorIdEleicao(this.idEleicao, this.token).then((data: any) => {
        this.candidaturaId = data.id;
            }, err => {
        console.log(err);
      })
    }

  // CSV
  importarCsv(event) {

    let arquivos = event.srcElement.files;

    if (this.validaTipoArquivo(arquivos[0])) {
      let input = event.target;
      let fileReader = new FileReader();
      fileReader.readAsText(input.files[0]);

      fileReader.onload = () => {
        let csvData = fileReader.result;
        let csvRecordsArray = csvData.toString().split(/\r\n|\n/);
        let headersRow = this.utils.getHeaderArray(csvRecordsArray);
        this.newBlacklistArray = this.getDataRecordsArrayFromCSVFile(csvRecordsArray, headersRow.length, this.candidaturaId);
      };
    }
  }

  validaTipoArquivo(file: any) {
    return file.name.endsWith(".csv");
  }

  getDataRecordsArrayFromCSVFile(csvRecordsArray: any, headerLength: any, candidaturaId: number) {
    let csvArr = [];

    for (let i = 1; i < csvRecordsArray.length; i++) {
      let currentRecord = csvRecordsArray[i];
      if (currentRecord.length != 0) {
        let csv:  BlacklistCandidaturaCsvDTO = new  BlacklistCandidaturaCsvDTO();
        csv.login = currentRecord;
        csv.candidaturaId = candidaturaId;
        csvArr.push(csv);
      }
    }
    return csvArr
  }
  private async insercaoEmMassa(blacklist:  BlacklistCandidaturaCsvDTO[]) {
    await this.blacklistService.inserirLoginsNaBlackListEmMassa(this.token, blacklist).then(() => {
      this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso!', detail: 'Blacklist enviada com sucesso!' });
      setTimeout(function () {
        window.location.reload();
      })
    }, err => {
      this.messageService.add({ key: 'toast', severity: 'error', summary: '', detail: 'Houve um erro ao enviar a blacklist selecionada, tente novamente!' });
    });
  }

  zerarInputFile(element){
    this.newBlacklistArray = [];
     element.value = '';
  }
  importarList(){
    this.insercaoEmMassa(this.newBlacklistArray);
  }
}
